<div *ngIf="!(sisifoUserHasRelatedCenter$ | async)">
  {{ "WEB_RESULTS.ERROR.NO_PERMISSION" | translate }}
</div>

<form
  [formGroup]="form"
  class="form-basic"
  (submit)="search()"
  autocomplete="off"
  *ngIf="sisifoUserHasRelatedCenter$ | async"
>
  <div class="form-field">
    <label for="history">{{
      "PATIENT_REQUESTS.SEARCH.HISTORY_NUMBER" | translate
    }}</label>
    <input
      id="history"
      type="text"
      pInputText
      formControlName="history"
      [maxlength]="16"
      autocomplete="off"
      [class.disabled]="form.get('history')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="externalHistory">{{
      "PATIENT_REQUESTS.SEARCH.EXTERNAL_HISTORY" | translate
    }}</label>
    <input
      id="externalHistory"
      type="text"
      pInputText
      [maxlength]="25"
      formControlName="externalHistory"
      [class.disabled]="form.get('externalHistory')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="lastName">{{
      "PATIENT_REQUESTS.SEARCH.LASTNAME" | translate
    }}</label>
    <input
      id="lastName"
      type="text"
      pInputText
      [maxlength]="100"
      formControlName="lastName"
      [class.disabled]="form.get('lastName')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="name">{{ "PATIENT_REQUESTS.SEARCH.NAME" | translate }}</label>
    <input
      id="name"
      type="text"
      [maxlength]="50"
      pInputText
      formControlName="name"
      [class.disabled]="form.get('name')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="selGender">{{
      "PATIENT_REQUESTS.SEARCH.GENDER" | translate
    }}</label>

    <p-dropdown
      id="selGender"
      [options]="genders"
      formControlName="gender"
      optionValue="id"
      optionLabel="description"
      [showClear]="true"
      appendTo="body"
      [class.disabled]="form.get('gender')?.disabled"
    >
    </p-dropdown>
  </div>

  <div class="form-field">
    <label for="birthDate">{{
      "PATIENT_REQUESTS.SEARCH.BIRTHDATE" | translate
    }}</label>
    <p-calendar
      dateFormat="dd/mm/yy"
      inputId="birthDate"
      formControlName="birthDate"
      [readonlyInput]="true"
      [firstDayOfWeek]="1"
      [showClear]="true"
      [class.disabled]="form.get('birthDate')?.disabled"
      [maxDate]="today"
    ></p-calendar>
  </div>

  <div class="form-field">
    <label for="extractionFrom">{{
      "PATIENT_REQUESTS.SEARCH.EXTRACTION_DATE_FROM" | translate
    }}</label>
    <p-calendar
      dateFormat="dd/mm/yy"
      inputId="extractionFrom"
      formControlName="extractionFrom"
      [readonlyInput]="true"
      [firstDayOfWeek]="1"
      [class.disabled]="form.get('extractionFrom')?.disabled"
      [maxDate]="form.get('extractionTo')?.value ?? today"
      [showButtonBar]="true"
    ></p-calendar>
  </div>

  <div class="form-field">
    <label for="extractionTo">{{
      "PATIENT_REQUESTS.SEARCH.EXTRACTION_DATE_TO" | translate
    }}</label>
    <p-calendar
      dateFormat="dd/mm/yy"
      inputId="extractionTo"
      formControlName="extractionTo"
      [readonlyInput]="true"
      [firstDayOfWeek]="1"
      [class.disabled]="form.get('extractionTo')?.disabled"
      [maxDate]="today"
      [minDate]="form.get('extractionFrom')?.value"
      [showButtonBar]="true"
    ></p-calendar>
  </div>

  <div class="form-field" *ngIf="sisifoUserHasRelatedDoctor$ | async">
    <h4>{{ "PATIENT_REQUESTS.SEARCH.BY_USER" | translate }}</h4>
    <p-checkbox
      [binary]="true"
      formControlName="searchByUser"
      inputId="searchByUser"
    ></p-checkbox>
  </div>

  <div class="btns-container">
    <p-button
      [label]="'PATIENT_REQUESTS.SEARCH.CLEAR' | translate"
      (click)="clear()"
    ></p-button>
    <p-button
      [label]="'PATIENT_REQUESTS.SEARCH.SEARCH' | translate"
      type="submit"
    ></p-button>
  </div>
</form>
